/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AppVersionSettingItem, AppVersionSettings } from 'src/luis/projects/apps/types/AppVersionSettings';

/**
 * Returns the value of the given setting from the given settings object.
 *
 * @param settings The settings to search in.
 * @param settingName The setting name to retrieve value for.
 * @returns The value of the setting.
 */
export const getAppVersionSettingValue = (
    settings: AppVersionSettings,
    settingName: AppVersionSettingItem['name']
): AppVersionSettingItem['value'] => {
    if (!settings) {
        return 'false';
    }

    if (settings) {
        const setting = settings.find(s => s.name === settingName);

        return setting ? setting.value.toLocaleLowerCase() : 'false';
    }
};
